import HttpRequest from '@/utils/axios'
import * as config from '@/config'
// const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

const axios = new HttpRequest(config.baseUrl)
export default axios
